@charset "UTF-8";
.vx-input {
  position: relative;
}

.vx-input__label {
  line-height: 1;
  color: var(--vx-input--text-color, #000);
}

.vx-input__label-position--left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.vx-input__label-position--left > .vx-input__label {
  padding-right: 10px;
}

.vx-input__label-position--right {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.vx-input__label-position--right > .vx-input__label {
  padding-left: 10px;
}

.vx-input__input {
  display: block;
  position: relative;
  width: 100%;
  font-size: var(--vx-input--font-size, 14px);
  accent-color: var(--vx-input-accent-color);
  color: var(--vx-input--text-color, #000);
  padding: var(--vx-input--padding, 9px);
  line-height: 1;
  margin: 0;
  border: 1px solid var(--vx-input--border-color, #B2B2B2);
  border-radius: var(--vx-input--border-radius, 4px);
  background: #fff;
}
.vx-input__input::placeholder {
  color: var(--vx-input--placeholder-text-color, #878787);
}
.vx-input__input[type=date] {
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-appearance: none;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in safari without prefix */
  -moz-appearance: none;
  appearance: none;
  text-align: left;
  height: 39px;
  box-sizing: border-box; /* Für konsistentes Padding */
}
.vx-input__input::-webkit-date-and-time-value {
  text-align: left;
}

.vx-input__input:focus {
  border: 1px solid var(--vx-input-accent-color, #888);
}

.vx-input__input:disabled {
  cursor: not-allowed;
}

.vx-input__style--minimal {
  border-bottom: 1px solid;
}
.vx-input__style--minimal input {
  border: 0;
}

.vx-input__icon {
  position: absolute;
  right: 12px;
  font-size: 0;
  line-height: 0;
  display: inline-block;
}

.vx-input__icon--lens::before {
  content: "";
  margin: 0;
  display: inline-block;
  mask-size: contain;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-repeat: no-repeat;
  background-color: var(--vx-input-lens-color, #878787);
  /* stylelint-disable-next-line function-url-quotes */
  mask-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.9128 4C8.43833 4 4 8.43728 4 13.9114C4 19.3856 8.43833 23.8229 13.9128 23.8229C16.0837 23.8229 18.0928 23.1245 19.7259 21.9406L25.3279 27.5416C25.9392 28.1529 26.9303 28.1528 27.5416 27.5414C28.1529 26.9301 28.1528 25.939 27.5414 25.3277L21.9403 19.7275C23.1261 18.094 23.8256 16.0838 23.8256 13.9114C23.8256 8.43728 19.3873 4 13.9128 4ZM7.13069 13.9114C7.13069 10.1667 10.1669 7.13065 13.9128 7.13065C17.6587 7.13065 20.6949 10.1667 20.6949 13.9114C20.6949 17.6562 17.6587 20.6922 13.9128 20.6922C10.1669 20.6922 7.13069 17.6562 7.13069 13.9114Z' fill='%2300869d'/%3E%3C/svg%3E");
  /* stylelint-disable-next-line function-url-quotes, property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.9128 4C8.43833 4 4 8.43728 4 13.9114C4 19.3856 8.43833 23.8229 13.9128 23.8229C16.0837 23.8229 18.0928 23.1245 19.7259 21.9406L25.3279 27.5416C25.9392 28.1529 26.9303 28.1528 27.5416 27.5414C28.1529 26.9301 28.1528 25.939 27.5414 25.3277L21.9403 19.7275C23.1261 18.094 23.8256 16.0838 23.8256 13.9114C23.8256 8.43728 19.3873 4 13.9128 4ZM7.13069 13.9114C7.13069 10.1667 10.1669 7.13065 13.9128 7.13065C17.6587 7.13065 20.6949 10.1667 20.6949 13.9114C20.6949 17.6562 17.6587 20.6922 13.9128 20.6922C10.1669 20.6922 7.13069 17.6562 7.13069 13.9114Z' fill='%2300869d'/%3E%3C/svg%3E");
  height: var(--vx-input__lens-icon-size, 22px);
  width: var(--vx-input__lens-icon-size, 22px);
}

.vx-input__icon--close::before {
  content: "";
  margin: 0;
  display: inline-block;
  mask-size: contain;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  /* stylelint-disable-next-line property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-repeat: no-repeat;
  background-color: var(--vx-input-lens-color, #878787);
  /* stylelint-disable-next-line function-url-quotes */
  mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MTAxIDEuNzA3MTFDMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMC42ODM0MTcgMTUuNzEwMSAwLjI5Mjg5M0MxNS4zMTk1IC0wLjA5NzYzMTEgMTQuNjg2NCAtMC4wOTc2MzExIDE0LjI5NTggMC4yOTI4OTNMOC4wMDE0NyA2LjU4NzI2TDEuNzA3MTEgMC4yOTI4OTNDMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IC0wLjA5NzYzMTEgMC4yOTI4OTMgMC4yOTI4OTNDLTAuMDk3NjMxMSAwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggMC4yOTI4OTMgMS43MDcxMUw2LjU4NzI2IDguMDAxNDdMMC4yOTI4OTMgMTQuMjk1OEMtMC4wOTc2MzExIDE0LjY4NjQgLTAuMDk3NjMxMSAxNS4zMTk1IDAuMjkyODkzIDE1LjcxMDFDMC42ODM0MTcgMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMS43MDcxMSAxNS43MTAxTDguMDAxNDcgOS40MTU2OUwxNC4yOTU4IDE1LjcxMDFDMTQuNjg2NCAxNi4xMDA2IDE1LjMxOTUgMTYuMTAwNiAxNS43MTAxIDE1LjcxMDFDMTYuMTAwNiAxNS4zMTk1IDE2LjEwMDYgMTQuNjg2NCAxNS43MTAxIDE0LjI5NThMOS40MTU2OSA4LjAwMTQ3TDE1LjcxMDEgMS43MDcxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=");
  /* stylelint-disable-next-line function-url-quotes, property-no-vendor-prefix -- mask-properties dont work in chrome without webkit-prefix */
  -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MTAxIDEuNzA3MTFDMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMC42ODM0MTcgMTUuNzEwMSAwLjI5Mjg5M0MxNS4zMTk1IC0wLjA5NzYzMTEgMTQuNjg2NCAtMC4wOTc2MzExIDE0LjI5NTggMC4yOTI4OTNMOC4wMDE0NyA2LjU4NzI2TDEuNzA3MTEgMC4yOTI4OTNDMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IC0wLjA5NzYzMTEgMC4yOTI4OTMgMC4yOTI4OTNDLTAuMDk3NjMxMSAwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggMC4yOTI4OTMgMS43MDcxMUw2LjU4NzI2IDguMDAxNDdMMC4yOTI4OTMgMTQuMjk1OEMtMC4wOTc2MzExIDE0LjY4NjQgLTAuMDk3NjMxMSAxNS4zMTk1IDAuMjkyODkzIDE1LjcxMDFDMC42ODM0MTcgMTYuMTAwNiAxLjMxNjU4IDE2LjEwMDYgMS43MDcxMSAxNS43MTAxTDguMDAxNDcgOS40MTU2OUwxNC4yOTU4IDE1LjcxMDFDMTQuNjg2NCAxNi4xMDA2IDE1LjMxOTUgMTYuMTAwNiAxNS43MTAxIDE1LjcxMDFDMTYuMTAwNiAxNS4zMTk1IDE2LjEwMDYgMTQuNjg2NCAxNS43MTAxIDE0LjI5NThMOS40MTU2OSA4LjAwMTQ3TDE1LjcxMDEgMS43MDcxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=");
  height: var(--vx-input__close-icon-size, 16px);
  width: var(--vx-input__close-icon-size, 16px);
}